import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RtiDealerOptionDetail } from './rti-dealer-option-detail';
import { RtiHtmlModule } from '../../common/rti-html/rti-html.module';
import {SharedModule} from "../../../../../app/shared/shared.module";

@NgModule({
  imports: [CommonModule, RtiHtmlModule, SharedModule],
  declarations: [RtiDealerOptionDetail],
  exports: [RtiDealerOptionDetail]
})
export class RtiDealerOptionDetailModule {
}
